/* custom-cl-pdp — PDP behaviour: gallery thumb swap, Grüns two-card offer (subscribe/one-time),
   cadence chips (singles), "За колко човека?" qty selector (bundle), sticky ATC reveal.
   Data contract: radios carry UNIT prices in data-price/data-compare (+data-days); rendered card
   figures = unit × qty (per-day stays per person). The cart payload is owned by custom-cl-atc.js
   (checked radio's data-plan + input[name=quantity]). */
(function () {
  function init(root) {
    if (!root || root.__clPdp) return;
    root.__clPdp = true;

    /* money helpers */
    /* reads a shown price in any language format (€1.173,00 · €1,173.00 · 29,75 €): the last , or . followed by 1–2 digits is the decimal mark */
    function moneyNum(s) {
      var t = String(s || '').replace(/[^\d,.]/g, ''), i = Math.max(t.lastIndexOf(','), t.lastIndexOf('.'));
      var dec = i >= 0 && /^\d{1,2}$/.test(t.slice(i + 1));
      var whole = (dec ? t.slice(0, i) : t).replace(/[.,]/g, '');
      return parseFloat(whole + (dec ? '.' + t.slice(i + 1) : '')) || 0;
    }
    function moneyFmt(n) { if (window.clMoney) return window.clMoney(Math.round(n * 100), true, root.getAttribute('data-cl-cur-display')); var r = Math.round(n * 100) / 100; return '€' + (r % 1 === 0 ? String(r) : r.toFixed(2).replace('.', ',')); }
    /* the first-delivery code is a euro amount: a shopper paying in local currency sees it at the store's rate */
    function cdFirstOff(c) {
      if (!c || root.getAttribute('data-cl-cur-display') === 'EUR' || !window.clCurCode || window.clCurCode === 'EUR') return c;
      return Math.round(c * (parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1));
    }
    function monthsOf(str) { var m = String(str || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }

    /* strings: rendered by the section from the locale layer onto the root, [placeholder] style */
    function tStr(name, fallback) { return root.getAttribute('data-cl-t-' + name) || fallback; }
    function perDayText(price) { return tStr('perday', '[price]/day').replace('[price]', price); }
    function cadPackText(pkg, weeks) { return tStr('cadpack', '[pkg] · every [weeks] weeks').replace('[pkg]', pkg).replace('[weeks]', weeks); }
    function cadOneText(pkg) { return tStr('cadone', '[pkg] · one delivery').replace('[pkg]', pkg); }
    function supplyText(months) { return tStr('supply', '[months]-month supply').replace('[months]', months); }

    /* ── Gallery: thumbnail → main swap ── */
    var main = root.querySelector('[data-cl-gallery-main]');
    function bindThumb(t) {
      t.addEventListener('click', function () {
        if (!main) return;
        var full = t.getAttribute('data-full');
        if (full) { main.src = full; main.srcset = ''; }
        root.querySelectorAll('[data-cl-thumb]').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-current', 'false'); });
        t.classList.add('is-active'); t.setAttribute('aria-current', 'true');
      });
    }
    root.querySelectorAll('[data-cl-thumb]').forEach(bindThumb);

    /* ── Kit per dose: the rail holds only the chosen dose's frames (data-cl-dose-gallery = {dose: [urls], "*": default}).
       The server renders the current dose; a dose pill rebuilds the rail and shows its first frame. ── */
    var dgRail = root.querySelector('[data-cl-dose-gallery]');
    var dgCur = null;
    function swapDoseGallery(dose) {
      if (!dgRail) return;
      if (dgCur === null) { dgCur = dose; return; }
      if (dose === dgCur) return;
      dgCur = dose;
      var map = {};
      try { map = JSON.parse(dgRail.getAttribute('data-cl-dose-gallery') || '{}'); } catch (e) { map = {}; }
      var list = map[dose] || map['*'];
      if (!list || !list.length) return;
      var tpl = dgRail.querySelector('[data-cl-thumb]');
      var label = tpl ? (tpl.getAttribute('aria-label') || '') : '';
      dgRail.innerHTML = '';
      list.forEach(function (src, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cl-pdp__thumb' + (i === 0 ? ' is-active' : '');
        b.setAttribute('data-cl-thumb', '');
        b.setAttribute('data-full', src);
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', label.replace(/\d+/, String(i + 1)));
        var im = document.createElement('img');
        im.src = src; im.width = 56; im.height = 56; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        bindThumb(b);
        dgRail.appendChild(b);
      });
      if (main) { main.src = list[0]; main.srcset = ''; }
    }

    /* ── Offer state ── */
    var planInput = root.querySelector('[data-cl-selling-plan]');
    var idInput = root.querySelector('input[name="id"]');
    var qtyInput = root.querySelector('input[name="quantity"]');
    var priceEls = root.querySelectorAll('[data-cl-price]');
    var compareEls = root.querySelectorAll('[data-cl-compare]');
    var qty = 1;

    function radioA() { return root.querySelector('input[name="cl-offer"][value^="plan-"]'); }
    function radioOne() { return root.querySelector('input[name="cl-offer"][value="one"]'); }
    function checkedOffer() { return root.querySelector('input[name="cl-offer"]:checked'); }

    /* paint every displayed figure from the radios' unit data + qty */
    function renderCards() {
      var rA = radioA(), rOne = radioOne();
      if (rA) {
        var opt = rA.closest('[data-cl-offer-opt]');
        var unit = moneyNum(rA.getAttribute('data-price'));
        var cmp = moneyNum(rA.getAttribute('data-compare'));
        var days = parseInt(rA.getAttribute('data-days') || '0', 10);
        var pe = opt.querySelector('[data-cl-plan-price]'); if (pe) pe.textContent = moneyFmt(unit * qty);
        var we = opt.querySelector('[data-cl-plan-was]');
        if (we) { we.textContent = cmp > unit ? moneyFmt(cmp * qty) : ''; we.style.display = cmp > unit ? '' : 'none'; }
        var pd = opt.querySelector('[data-cl-plan-perday]');
        if (pd && days) pd.textContent = perDayText(moneyFmt(Math.round((unit / days) * 100) / 100));
        var bs = root.querySelector('[data-cl-banner-save]');
        if (bs && cmp > 0) bs.textContent = Math.floor(Math.round(((cmp - unit) / cmp) * 10000) / 100) + '%';
      }
      if (rOne) {
        var unitO = moneyNum(rOne.getAttribute('data-price'));
        var daysO = parseInt(rOne.getAttribute('data-days') || '0', 10);
        var peO = root.querySelector('[data-cl-one-price]'); if (peO) peO.textContent = moneyFmt(unitO * qty);
        var pdO = root.querySelector('[data-cl-one-perday]');
        if (pdO && daysO) pdO.textContent = perDayText(moneyFmt(Math.round((unitO / daysO) * 100) / 100));
      }
      var note = root.querySelector('[data-cl-qty2-note]');
      if (note) { var r = checkedOffer(); note.hidden = !(qty === 2 && r && r.value === 'one'); }
    }

    function syncOffer(radio) {
      if (!radio) return;
      if (planInput) planInput.value = radio.getAttribute('data-plan') || '';
      var price = radio.getAttribute('data-price') || '';
      var compare = radio.getAttribute('data-compare') || '';
      priceEls.forEach(function (el) { el.textContent = price; });
      compareEls.forEach(function (el) { el.textContent = compare; el.style.display = compare ? '' : 'none'; });
      root.querySelectorAll('[data-cl-offer-opt]').forEach(function (o) {
        o.classList.toggle('is-selected', o.contains(radio));
      });
      renderCards();
    }
    var radios = root.querySelectorAll('input[name="cl-offer"]');
    radios.forEach(function (r) { r.addEventListener('change', function () { syncOffer(r); }); });

    /* ── "За колко човека?" (bundle): qty → form quantity + displayed totals ── */
    root.querySelectorAll('[data-cl-qty-pill]').forEach(function (p) {
      p.addEventListener('click', function () {
        qty = parseInt(p.getAttribute('data-qty') || '1', 10) || 1;
        root.querySelectorAll('[data-cl-qty-pill]').forEach(function (x) {
          var on = x === p;
          x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (qtyInput) qtyInput.value = qty;
        root.querySelectorAll('[data-cl-vstack-qty]').forEach(function (el) {
          var base = parseInt(el.getAttribute('data-cl-vstack-qty') || '0', 10);
          if (base) el.textContent = '× ' + (base * qty);
        });
        renderCards();
        var now = checkedOffer(); if (now) syncOffer(now);
      });
    });

    /* ── Dose selector (flagship singles): swap variant / prices / image / chips / modal facts ── */
    var doseCur = root.querySelector('[data-cl-dose-cur]');
    function setText(sel, val, ctx) { (ctx || root).querySelectorAll(sel).forEach(function (el) { el.textContent = val; }); }
    function applyDose(pill) {
      if (!pill) return;
      root.querySelectorAll('[data-cl-dose-pill]').forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('aria-pressed', 'false'); });
      pill.classList.add('is-active'); pill.setAttribute('aria-pressed', 'true');
      var price = pill.getAttribute('data-price');
      if (idInput) idInput.value = pill.getAttribute('data-variant');
      if (doseCur) doseCur.textContent = pill.getAttribute('data-label');
      var plans = [];
      try { plans = JSON.parse(pill.getAttribute('data-plans') || '[]'); } catch (x) {}
      /* refresh the subscribe card from this dose's allocation for its plan */
      var rA0 = radioA();
      if (rA0) {
        var mA = plans.filter(function (pl) { return String(pl.id) === String(rA0.getAttribute('data-plan')); })[0];
        if (mA) {
          rA0.setAttribute('data-price', mA.price);
          rA0.setAttribute('data-compare', mA.compare || '');
        }
      }
      var rOne = radioOne(); if (rOne) rOne.setAttribute('data-price', price);
      if (main) { var im = pill.getAttribute('data-image'); if (im) { main.src = im; main.srcset = ''; } }
      var thumbs = root.querySelectorAll('[data-cl-thumb]');
      thumbs.forEach(function (x, ix) { var on = ix === 0; x.classList.toggle('is-active', on); x.setAttribute('aria-current', on ? 'true' : 'false'); });
      if (thumbs[0]) { var im2 = pill.getAttribute('data-image'); if (im2) { thumbs[0].setAttribute('data-full', im2); var ti = thumbs[0].querySelector('img'); if (ti) ti.src = im2; } }
      var fa = document.querySelector('[data-cl-fact-amount]'); if (fa && pill.getAttribute('data-folate')) fa.textContent = pill.getAttribute('data-folate');
      var fn = document.querySelector('[data-cl-fact-nrp]'); if (fn && pill.getAttribute('data-nrp')) fn.textContent = pill.getAttribute('data-nrp');
      /* the flat label differs per dose — keep the modal's artwork in step with the facts */
      var li = pill.getAttribute('data-labelimg');
      if (li) {
        var la = document.querySelector('[data-cl-label]');
        if (la) { la.setAttribute('href', li); var lim = la.querySelector('img'); if (lim) lim.src = li; }
      }
      var nowChecked = checkedOffer();
      if (nowChecked) syncOffer(nowChecked); else renderCards();
    }
    root.querySelectorAll('[data-cl-dose-pill]').forEach(function (p) { p.addEventListener('click', function () { applyDose(p); }); });
    var activeDose = root.querySelector('[data-cl-dose-pill].is-active');
    if (activeDose && doseCur) doseCur.textContent = activeDose.getAttribute('data-label');

    /* ── Bundle dose selector: subscribe card always prices on the BASE (3-месечен) pack;
       the MSRP strike = the same supply bought as individual products (data-msrp on the pill) ── */
    var bsel = root.querySelector('[data-cl-bsel]');
    if (bsel) {
      var vmap = {};
      try { vmap = JSON.parse(bsel.getAttribute('data-vmap') || '{}'); } catch (e) { vmap = {}; }
      var vstack = root.querySelector('[data-cl-vstack]');
      var basePkg = bsel.getAttribute('data-basepkg') || bsel.getAttribute('data-pkg');
      function curDose() { return bsel.getAttribute('data-dose'); }
      /* re-read on use: the currency toggle (custom-cl-cur.js) swaps data-vmap to euros */
      function vFor(pkg) { try { vmap = JSON.parse(bsel.getAttribute('data-vmap') || '{}'); } catch (e) { vmap = {}; } return vmap[curDose() + '|' + pkg]; }
      function applyBundle() {
        var vBase = vFor(basePkg);
        if (!vBase) return;
        swapDoseGallery(curDose());
        var curEl = root.querySelector('[data-cl-bsel-cur]'); if (curEl) curEl.textContent = curDose();
        var activePill = null;
        root.querySelectorAll('[data-cl-bsel-dose]').forEach(function (p) {
          var on = p.getAttribute('data-value') === curDose();
          p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false');
          if (on) activePill = p;
        });
        var rA = radioA();
        var baseMonths = monthsOf(basePkg) || 3;
        if (rA) {
          var m = (vBase.plans || []).filter(function (pl) { return String(pl.id) === String(rA.getAttribute('data-plan')); })[0];
          var firstOff = cdFirstOff(parseInt(rA.getAttribute('data-first-off') || '0', 10)) / 100;
          if (m) {
            var ongoing = moneyNum(m.price);
            rA.setAttribute('data-price', moneyFmt(Math.max(ongoing - firstOff, 0)));
            var og = root.querySelector('[data-cl-sub-ongoing]');
            if (og) og.textContent = moneyFmt(ongoing);
          }
          var msrp = activePill && activePill.getAttribute('data-msrp');
          if (msrp) rA.setAttribute('data-compare', msrp);
          /* deep-link hardening: a ?variant=<6-мес> URL server-renders 6-мес days/cadence, but the
             engine always prices the base pack — keep days + both cadence lines base-true too. */
          rA.setAttribute('data-days', String(baseMonths * 30));
          var cadA = root.querySelector('[data-cl-sub-cad]');
          if (cadA) cadA.textContent = cadPackText(basePkg, baseMonths * 4);
        }
        var rOne0 = radioOne();
        if (rOne0) {
          rOne0.setAttribute('data-days', String(baseMonths * 30));
          var cadB = rOne0.closest('[data-cl-offer-opt]');
          cadB = cadB && cadB.querySelector('.cl-offer__cad');
          if (cadB) cadB.textContent = cadOneText(basePkg);
        }
        var rOne = radioOne(); if (rOne) rOne.setAttribute('data-price', vBase.price);
        if (idInput) idInput.value = vBase.id;
        if (vstack) {
          var months = monthsOf(basePkg);
          if (months) vstack.querySelectorAll('[data-cl-vstack-supply]').forEach(function (el) { el.textContent = supplyText(months); });
          var doseEl = vstack.querySelector('[data-cl-vstack-dose]');
          if (doseEl) doseEl.textContent = curDose();
        }
        var nowChecked = checkedOffer();
        if (nowChecked) syncOffer(nowChecked); else renderCards();
      }
      root.querySelectorAll('[data-cl-bsel-dose]').forEach(function (p) {
        p.addEventListener('click', function () { bsel.setAttribute('data-dose', p.getAttribute('data-value')); applyBundle(); });
      });
      applyBundle();
    }

    /* first paint */
    var checked = checkedOffer();
    if (checked) syncOffer(checked); else renderCards();

    /* ── Sticky ATC: rAF-throttled scroll check (NOT IntersectionObserver — logged trap) ── */
    var sentinel = root.querySelector('[data-cl-sticky-anchor]');
    var sticky = root.querySelector('[data-cl-pdp-sticky]');
    if (sentinel && sticky) {
      var ticking = false;
      function check() {
        ticking = false;
        var past = sentinel.getBoundingClientRect().bottom < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(check); }
      }, { passive: true });
      check();
    }
  }

  function boot() { document.querySelectorAll('[data-cl-pdp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
